import './App.css';
import React, {useEffect, useState, useRef} from 'react';
import React360Viewer from "./EmbedReact360Viewer";

function App(config) {
  //const [CheckboxOpen, setCheckboxOpen] = useState(false);
  const [ActiveSpinner, setActiveSpinner] = useState(1);
  const [ConfigJson,setConfigJson] = useState([{}]);

  const hasBeenFocused = useRef(false);
  //const CheckboxContainerRef = useRef(null);
  
  useEffect(()=>{

     setConfigJson(config.config.SpinnerInfo);

  },[config.config.SpinnerInfo])


  function ChangeSpinner(SpinnerId){

    if (ActiveSpinner !== parseInt(SpinnerId))
    {
      hasBeenFocused.current = true;
      setActiveSpinner(SpinnerId);
    }

  };

/*   function OpenCheckBox(){

      setCheckboxOpen(!CheckboxOpen);

      if(CheckboxContainerRef != null){
        if(!CheckboxOpen){
          //Show Checkbox
          CheckboxContainerRef.current.classList.remove('DBGCheckbox-hide')
          CheckboxContainerRef.current.classList.remove('DBGCheckbox-hidden')
          CheckboxContainerRef.current.classList.add('DBGCheckbox-show')
        }else{
            //Hide Checkbox
            CheckboxContainerRef.current.classList.remove('DBGCheckbox-show')
            CheckboxContainerRef.current.classList.remove('DBGCheckbox-hidden')
            CheckboxContainerRef.current.classList.add('DBGCheckbox-hide')
        }
      }

      console.log("Open Checkbox:");
      console.log("Jobname: " + ConfigJson[ActiveSpinner-1].Checkbox.jobname);
      console.log("DBG Job Number: " + ConfigJson[ActiveSpinner-1].Checkbox.jobnumber);
      console.log("client: " + ConfigJson[ActiveSpinner-1].Checkbox.client);
      console.log("date: " + ConfigJson[ActiveSpinner-1].Checkbox.date);
  };
 */

  return (
      <div className="container-fluid MainContainer NoBorder">
        <div className="row NoBorder">
          <div className="col-12 mb-4 card p-0 NoBorder">
            {ConfigJson.map((spinner,i) =>
              <div key={i}>
                  {(ActiveSpinner === parseInt(spinner.id)) ? 
                  <div key={i}>
                    <React360Viewer
                      amount={parseInt(spinner.frames)}
                      imagePath={spinner.foldername}
                      fileName="{index}.jpg?v1"
                      autoplay={(config.config.Autoplay === "true")}
                      spinReverse={false}
                      buttonClass="light"
                      containerID={config.config.DivName}
                      preloadImages={(config.config.Preload === "true") || hasBeenFocused.current === true}
                    />
                  </div>
                  : <></>}
              </div>
            )}
          </div>
        </div>
        
        <div className='SpinnerButtonFlexContainer'>
{/*             <div className='SpinnerCheckboxButtonContainer'>
              
              
              <div className='SpinnerCheckboxContainer DBGCheckbox-hidden' ref={CheckboxContainerRef}>
                <div className='DBGCheckbox'>
                    {ConfigJson.length > 1? 
                    <DBGCheckbox
                      JSONjobname={ConfigJson[ActiveSpinner - 1].Checkbox.jobname}
                      JSONjobnumber={ConfigJson[ActiveSpinner - 1].Checkbox.jobnumber}
                      JSONclient={ConfigJson[ActiveSpinner - 1].Checkbox.client}
                      JSONdate={ConfigJson[ActiveSpinner - 1].Checkbox.date}
                    />:
                     ''}
                </div>
              </div>
              
              <div className="SpinnerCheckboxButton" onClick={() => OpenCheckBox()}>
                ?
              </div>
            </div> */}
            {ConfigJson.length > 1?
            <div className='SpinnerButtonContainer'>

              {ConfigJson.map((spinner,i) => 
                    <div key={i} className={ActiveSpinner === parseInt(spinner.id) ? "SpinnerButton SpinnerButtonActive" : "SpinnerButton"} onClick={() => ChangeSpinner(spinner.id)}>
                      {spinner.name}
                    </div>
              )} 

            </div>
            : <></>}  
          </div>
        </div>             
      
  );
}

export default App;
